/* ============================================================
   GOOD ELECTROLYTES — theme JS
   Cart uses Shopify's Cart AJAX API. No hardcoded prices.
   ============================================================ */
(function () {
  "use strict";
  window.GN = window.GN || {};
  window.GN.strings = window.GN.strings || {};
  var S = window.GN.strings;
  S.addToCart = S.addToCart || "Add to cart";
  S.soldOut   = S.soldOut   || "Sold out";
  S.cartEmpty = S.cartEmpty || "Your cart is empty.";
  var R = window.GN.routes || {};

  /* ---------- money ----------
     Shopify's money_format uses one of four placeholders and the store's own
     separators. Formatting only the decimal case produced "$1234.00" on any
     cart over a thousand, so each variant is handled explicitly. */
  function money(cents) {
    var fmt = (window.GN && window.GN.moneyFormat) || "${{amount}}";
    function group(thousands, decimal, places) {
      var n = (cents / 100).toFixed(places);
      var parts = n.split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return places ? parts.join(decimal) : parts[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function(_, name){
      switch (name) {
        case "amount":                       return group(",", ".", 2);
        case "amount_no_decimals":           return group(",", ".", 0);
        case "amount_with_comma_separator":  return group(".", ",", 2);
        case "amount_no_decimals_with_comma_separator": return group(".", ",", 0);
        case "amount_with_apostrophe_separator": return group("'", ".", 2);
        case "amount_no_decimals_with_space_separator": return group(" ", ",", 0);
        case "amount_with_space_separator":  return group(" ", ",", 2);
        case "amount_with_period_and_space_separator": return group(" ", ".", 2);
        default:                             return group(",", ".", 2);
      }
    });
  }

  /* ---------- drawers ---------- */
  var scrim = document.getElementById("scrim");
  var cart = document.getElementById("CartDrawer");
  var menu = document.getElementById("MobileMenu");

  function lock(){ document.body.style.overflow = "hidden"; }
  function unlock(){ document.body.style.overflow = ""; }
  function closeAll(){
    if (cart) cart.classList.remove("open");
    if (menu) menu.classList.remove("open");
    if (scrim) scrim.classList.remove("open");
    unlock();
  }
  function openCart(){ if(menu) menu.classList.remove("open"); if(scrim) scrim.classList.add("open"); if(cart) cart.classList.add("open"); lock(); }
  function openMenu(){ if(cart) cart.classList.remove("open"); if(scrim) scrim.classList.add("open"); if(menu) menu.classList.add("open"); lock(); }

  if (scrim) scrim.addEventListener("click", closeAll);
  document.addEventListener("keydown", function(e){ if(e.key === "Escape") closeAll(); });

  /* ---------- render cart from Shopify state ---------- */
  function renderCart(state){
    var countEl = document.getElementById("CartCount");
    if (countEl){
      countEl.textContent = state.item_count;
      countEl.classList.toggle("show", state.item_count > 0);
    }
    var itemsEl = document.getElementById("CartItems");
    var subEl = document.getElementById("CartSubtotal");
    var checkout = document.getElementById("CartCheckout");
    if (!itemsEl) return;

    if (!state.items.length){
      itemsEl.innerHTML = '<div class="cart__empty">' + window.GN.strings.cartEmpty + '</div>';
      if (checkout){ checkout.disabled = true; checkout.style.opacity = ".5"; }
    } else {
      itemsEl.innerHTML = state.items.map(function(it){
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, "_120x150_crop_center$1$2") : "";
        return '<div class="citem" data-key="' + it.key + '">' +
          '<div class="citem__thumb">' + (img ? '<img class="media-fill" src="' + img + '" alt="">' : '') + '</div>' +
          '<div class="citem__info"><b>' + it.product_title + '</b>' +
            (it.variant_title && it.variant_title !== "Default Title" ? '<span>' + it.variant_title + '</span>' : '') +
            '<div class="citem__qty">' +
              '<button class="qbtn" data-qty="' + it.key + '" data-to="' + (it.quantity - 1) + '" aria-label="Decrease">–</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button class="qbtn" data-qty="' + it.key + '" data-to="' + (it.quantity + 1) + '" aria-label="Increase">+</button>' +
            '</div>' +
          '</div>' +
          '<div class="citem__price">' + money(it.final_line_price) + '</div>' +
        '</div>';
      }).join("");
      if (checkout){ checkout.disabled = false; checkout.style.opacity = "1"; }
    }
    if (subEl) subEl.textContent = money(state.total_price);
  }

  function fetchCart(){
    return fetch(R.cart + ".js", {headers:{"Accept":"application/json"}})
      .then(function(r){ return r.json(); }).then(renderCart)
      .catch(function(){ /* offline or blocked — leave the drawer as-is */ });
  }

  function flashError(msg){
    var el = document.getElementById("CartError");
    if (!el){
      var host = document.getElementById("CartItems");
      if (!host || !host.parentNode) { console.error(msg); return; }
      el = document.createElement("p");
      el.id = "CartError";
      el.setAttribute("role", "alert");
      el.className = "cart__error";
      host.parentNode.insertBefore(el, host);
    }
    el.textContent = msg;
    el.hidden = false;
  }
  function clearError(){
    var el = document.getElementById("CartError");
    if (el) el.hidden = true;
  }

  function addToCart(id, qty){
    clearError();
    return fetch(R.cartAdd, {
      method:"POST",
      headers:{"Content-Type":"application/json","Accept":"application/json"},
      body: JSON.stringify({items:[{id:id, quantity:qty||1}]})
    }).then(function(r){
      return r.json().then(function(body){
        // Shopify answers 422 with {description} when stock or limits block the add.
        if (!r.ok) throw new Error(body.description || body.message || "We couldn't add that to your cart.");
        return body;
      });
    })
      .then(function(){ return fetchCart(); })
      .then(openCart)
      .catch(function(err){ openCart(); flashError(err.message); });
  }

  function changeQty(key, to){
    clearError();
    return fetch(R.cartChange, {
      method:"POST",
      headers:{"Content-Type":"application/json","Accept":"application/json"},
      body: JSON.stringify({id:key, quantity: Math.max(0, to)})
    }).then(function(r){
      return r.json().then(function(body){
        if (!r.ok) throw new Error(body.description || body.message || "We couldn't update that quantity.");
        return body;
      });
    }).then(renderCart)
      .catch(function(err){ flashError(err.message); return fetchCart(); });
  }

  /* ---------- delegated events ---------- */
  document.addEventListener("click", function(e){
    var t = e.target.closest("[data-add-id],[data-qty],[data-open-cart],[data-close-cart],[data-open-menu],[data-close-menu]");
    if (!t) return;
    if (t.hasAttribute("data-open-menu")){ e.preventDefault(); openMenu(); return; }
    if (t.hasAttribute("data-close-menu")){ e.preventDefault(); closeAll(); return; }
    if (t.hasAttribute("data-open-cart")){ e.preventDefault(); openCart(); fetchCart(); return; }
    if (t.hasAttribute("data-close-cart")){ e.preventDefault(); closeAll(); return; }
    if (t.hasAttribute("data-qty")){ e.preventDefault(); changeQty(t.getAttribute("data-qty"), parseInt(t.getAttribute("data-to"),10)); return; }
    if (t.hasAttribute("data-add-id")){
      e.preventDefault();
      var qi = document.getElementById("Quantity");
      var q = (t.hasAttribute("data-use-qty") && qi) ? parseInt(qi.value,10) || 1 : 1;
      t.classList.add("is-loading");
      addToCart(t.getAttribute("data-add-id"), q)
        .then(function(){ t.classList.remove("is-loading"); },
              function(){ t.classList.remove("is-loading"); });
    }
  });

  if (menu) menu.querySelectorAll("a").forEach(function(a){ a.addEventListener("click", closeAll); });

  /* ---------- FAQ accordion ---------- */
  document.querySelectorAll(".faq__q").forEach(function(btn){
    btn.addEventListener("click", function(){
      var item = btn.closest(".faq__item");
      var open = item.classList.contains("open");
      var list = btn.closest(".faq__list");
      if (list) list.querySelectorAll(".faq__item").forEach(function(i){ i.classList.remove("open"); i.querySelector(".faq__q").setAttribute("aria-expanded","false"); });
      if (!open){ item.classList.add("open"); btn.setAttribute("aria-expanded","true"); }
    });
  });

  /* ---------- sticky mobile CTA ---------- */
  var mbar = document.getElementById("MobileBar");
  if (mbar){
    var shown = false;
    var onScroll = function(){
      var show = (window.scrollY || document.documentElement.scrollTop) > 520;
      if (show !== shown){ mbar.classList.toggle("show", show); shown = show; }
    };
    window.addEventListener("scroll", onScroll, {passive:true});
    onScroll();
  }

  /* ---------- reveal on scroll ---------- */
  if ("IntersectionObserver" in window){
    var io = new IntersectionObserver(function(en){
      en.forEach(function(x){ if(x.isIntersecting){ x.target.classList.add("in"); io.unobserve(x.target); } });
    }, {threshold:0.12});
    document.querySelectorAll(".reveal").forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll(".reveal").forEach(function(el){ el.classList.add("in"); });
  }

  /* ---------- PDP variant switching ---------- */
  var pdp = document.getElementById("ProductVariants");
  if (pdp){
    var data = JSON.parse(pdp.textContent);
    var addBtn = document.getElementById("AddToCart");
    var priceEl = document.getElementById("ProductPrice");
    var mainImg = document.getElementById("ProductImage");
    var titleEl = document.getElementById("VariantTitle");

    function select(id){
      var v = data.find(function(x){ return String(x.id) === String(id); });
      if (!v) return;
      if (addBtn){
        addBtn.setAttribute("data-add-id", v.id);
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available
          ? (window.GN.strings.addToCart + " · " + money(v.price))
          : window.GN.strings.soldOut;
      }
      if (priceEl) priceEl.textContent = money(v.price);
      if (mainImg && v.image){ mainImg.src = v.image; mainImg.alt = v.name; }
      if (titleEl) titleEl.textContent = v.title;
      document.querySelectorAll("[data-variant-id]").forEach(function(b){
        b.setAttribute("aria-pressed", String(b.getAttribute("data-variant-id")) === String(id) ? "true" : "false");
      });
      var url = new URL(window.location);
      url.searchParams.set("variant", v.id);
      window.history.replaceState({}, "", url);
    }
    document.querySelectorAll("[data-variant-id]").forEach(function(b){
      b.addEventListener("click", function(){ select(b.getAttribute("data-variant-id")); });
    });
    var qi = document.getElementById("Quantity");
    if (qi){
      document.querySelectorAll("[data-qty-step]").forEach(function(b){
        b.addEventListener("click", function(){
          var n = parseInt(qi.value,10) || 1;
          qi.value = Math.max(1, n + parseInt(b.getAttribute("data-qty-step"),10));
        });
      });
    }
  }

  fetchCart();
})();
